/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import ButtonLinkCell from '@/backgrid/ButtonLinkCell';
import PageableCollection from '@/backbone/PageableCollection';

const CustomerDashboardGridView = GridView.extend({
  initialize() {
    (this.options.columns = [
      {
        name: 'otdsUserId',
        label: 'User ID',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },

      {
        name: 'name',
        label: 'Name',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },
      {
        name: 'email',
        label: 'Email',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },
      {
        name: 'telephone',
        label: 'Telephone',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },
      {
        name: '',
        label: '',
        width: 20,
        editable: false,
        sortable: false,
        cell: ButtonLinkCell.extend({
          name: 'View',
          buttonClass: 'btn-sm btn-outline-primary',
          href(model) {
            return `#customer/${model.get('id')}`;
          },
          newTab: true
        })
      }
    ]),
      (this.collection = new PageableCollection([], { pageSize: 50 }));
    this.options.emptyText = 'No Customers Found';
    GridView.prototype.initialize?.apply(this, this.options);
  }
});

export default CustomerDashboardGridView;
